import React from 'react';
import { Stack, Box, Typography, AppBar } from '@mui/material';
import { useMCContext } from '../contexts/useMCStates';
import { CartBlock } from './CartBlock';
import { AccountHeaderBlock } from './AccountHeaderBlock';
import { MarqueeBanner } from './MarqueeBanner';

const QUILTED_FLAG_LOGO = `${process.env.PUBLIC_URL || ''}/Quilted Flag - Bold Zoom Tilt.png`;

interface MCHeaderProps {
    label: string;
    showCart: boolean;
    showMarquee?: boolean;
    /** When true, the hamburger FAB is visible and overlapping the header - hide the logo */
    hamburgerFabVisible?: boolean;
}

export const MCHeader = ({ label, showCart, showMarquee, hamburgerFabVisible }: MCHeaderProps) => {
    const { factor, appTheme, windowSize } = useMCContext();

    const isMobile = windowSize.isMobile;
    const showLogo = (!window.location.href.includes('myAccount') || !isMobile) && !hamburgerFabVisible;

    const logoSize = isMobile ? 36 : 52;
    const titleVariant = isMobile ? 'h6' : 'h5';

    return (
        <AppBar id='moment-central-header-ab' position='static' elevation={4} sx={{ backgroundColor: 'primary.main', padding: 0, margin: 0, zIndex: 1100, position: 'relative' }}>
            <Stack direction={'column'} sx={{ width: '100%' }}>
                <Stack
                    direction={'row'}
                    spacing={isMobile ? 1.5 : 2}
                    sx={{
                        padding: isMobile ? `0px ${12 * factor}px` : `0px ${24 * factor}px`,
                        alignItems: 'center',
                        minHeight: 56,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0,
                            width: logoSize * (factor < 1 ? factor : 1),
                            height: logoSize * 1.1 * (factor < 1 ? factor : 1),
                        }}
                    >
                        {showLogo ? (
                            <img
                                src={QUILTED_FLAG_LOGO}
                                alt="Moment Central Logo"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                }}
                            />
                        ) : null}
                    </Box>
                    <Typography
                        variant={titleVariant}
                        sx={{
                            fontWeight: 600,
                            color: appTheme.palette.secondary.main,
                            textAlign: 'left',
                            flex: 4,
                            marginLeft: showLogo ? (isMobile ? 0.5 : 1) : 0,
                        }}
                    >
                        {label}
                    </Typography>
                    <Box sx={{ flex: 1, minWidth: 8 }} />
                    {showCart && (
                        <CartBlock
                            props={{
                                appTheme: appTheme,
                            }}
                        />
                    )}
                    <AccountHeaderBlock
                        props={{
                            paddingWidth: 20 * factor,
                            headerName: 'moment-central-header-ab',
                            bgOn: `${appTheme.palette.secondary.main}`,
                            bgOff: 'lightgrey',
                        }}
                    />
                </Stack>
                {showMarquee && <MarqueeBanner />}
            </Stack>
        </AppBar>
    );
};
